import { Identifiable, CalendarHolidays, Holiday } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type CalendarHolidaysResponse = {
  _embedded?: {
    calendarHolidayses: Identifiable<CalendarHolidays>[];
  };
};

type HolidaysResponse = {
  _embedded?: {
    holidays: Identifiable<Holiday>[];
  };
};

function getHolidays(
  httpClient: HttpClient,
  calendarUuid: string,
): Promise<Identifiable<Holiday>[]> {
  return httpClient
    .sendHttpRequest<HolidaysResponse>({
      endpoint: `/calendarHolidayses/${calendarUuid}/holidays`,
      method: HttpMethods.GET,
    })
    .then((response) => response._embedded?.holidays || [])
    .catch((error) => {
      return Promise.reject({
        ...error,
        message: error.detail,
      });
    });
}

function getCalendarsHolidays(httpClient: HttpClient) {
  return (): Promise<Identifiable<CalendarHolidays>[]> =>
    httpClient
      .sendHttpRequest<CalendarHolidaysResponse>({
        endpoint: "/calendarHolidayses",
        method: HttpMethods.GET,
      })
      .then((response) => {
        const calendars = response._embedded?.calendarHolidayses || [];
        const calendarPromises = calendars.map((calendar) =>
          getHolidays(httpClient, calendar.uuid).then((holidays) => {
            calendar.holidays = holidays;
            return calendar;
          }),
        );
        return Promise.all(calendarPromises);
      })
      .catch((error) => {
        return Promise.reject({
          ...error,
          message: error.detail,
        });
      });
}

export { getCalendarsHolidays };
